export { DaoProposalMultipleUpdatePreProposeConfigAction } from './UpdatePreProposeConfig'
export { DaoProposalMultipleUpdateConfigAction } from './UpdateProposalConfig'
